import { render, staticRenderFns } from "./google.vue?vue&type=template&id=dfa2d600&scoped=true"
import script from "./google.vue?vue&type=script&lang=js"
export * from "./google.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa2d600",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa2d600')) {
      api.createRecord('dfa2d600', component.options)
    } else {
      api.reload('dfa2d600', component.options)
    }
    module.hot.accept("./google.vue?vue&type=template&id=dfa2d600&scoped=true", function () {
      api.rerender('dfa2d600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/google.vue"
export default component.exports